import { DatePipe } from "@angular/common";
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit
} from "@angular/core";
import { BsModalService } from "ngx-bootstrap/modal";
import { Subscription, debounceTime, firstValueFrom, tap } from "rxjs";
import { AppState, RoleMgr, ShowRequest } from "../../core";
import { UserService } from "../../core/services";
import {
  TableColumn,
  TableViewComponentBase,
  TableViewQueryRequest,
  TableViewQueryResponse
} from "../../shared/components/table-view/table-view-component-base";
import { VolunteerPointViewRecord } from "../models/volunteer-point-record";
import { VolunteerTaskViewService } from "../services/volunteer-task-view.service";
import { VolunteerTaskService } from "../services/volunteer-task.service";
import { VolunteerService } from "../services/volunteer.service";
import { AppConfig } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { VolunteerEditComponent } from "../volunteer-edit/volunteer-edit.component";
import { VolunteerPointViewService } from "../services/volunteer-point-view.service";

@Component({
  selector: "app-volunteer-points-table",
  templateUrl: "../../shared/components/table-view/table-view.component.html",
  styleUrls: [
    "../../shared/components/table-view/scss/table-view.scss",
    "../../shared/components/table-view/scss/app-tab-full-height.scss",
    "../../shared/components/table-view/scss/fixed-headers-and-column.scss",
  ],
})
export class VolunteerPointsTableComponent
  extends TableViewComponentBase<VolunteerPointViewRecord>
  implements OnInit, OnDestroy
{

  filterKeyUpSubscription: Subscription;
  //volunteerPointViewUrlPath = `${AppConfig.apiUrl}/volunteerPointView`;

  constructor(
    appState: AppState,
    modalService: BsModalService,
    public volunteerService: VolunteerService,
    public volunteerTaskService: VolunteerTaskService,
    public volunteerTaskViewService: VolunteerTaskViewService,
    public volunteerPointViewService: VolunteerPointViewService,
    elementRef: ElementRef,
    datePipe: DatePipe,
    public roleMgr: RoleMgr,
    public userService: UserService,
    public http: HttpClient,

  ) {
    super(appState, modalService, elementRef, datePipe);

    const idColumn: TableColumn = { title: "ID", name: "id", visible: false };

    this.tableColumns = [
      idColumn,
      { title: "User ID", name: "volunteerId", template: "userLink", visible: true},
      { title: "User Name", name: "volunteerName", visible: true},
      { title: "Building ID", name: "buildingId", template: "buildingLink", visible: true},
      { title: "Building Name", name: "buildingName", visible: true},
      { title: "Building Address", name: "civicAddress", visible: false},
      { title: "Building Floor", name: "floorAndDescript", visible: false},
      { title: "Building Description", name: "locationDescription", visible: false},
      { title: "Path ID", name: "pathId", visible: true},
      { title: "Point ID", name: "pointId", visible: true},
      { title: "Latitude", name: "latitude", visible: true},
      { title: "Longitude", name: "longitude", visible: true},
      { title: "Deleted", name: "deleted", template: 'badboolean', visible: true},      
      { title: "Modified By", name: "modifiedByName", visible: true },
      { title: "Modified (local)", name: "modifiedAt", template: "localtime", visible: true },
    ];

    this.sortColumns = [
      //{ key: 'id', order: 'ASC'},
      { key: 'volunteerId', order: 'ASC'},
    ];

    this.idColumns = [idColumn];
    //this.bStickyBulkActions = true;
    this.bShowBulkActionsColumn = false;
    this.pageSize = 40; // no paging if null
    this.bShowHeader = true;
  }

  doQuery = async (queryReq: TableViewQueryRequest) => {

    try {
      const resp = await this.volunteerPointViewService.find(queryReq);
      return resp;
    } catch (error) {
      console.error("find() error: " + error?.message);
      throw error;
    }
  }
  
  initKeyUpSubscription = () => {
    this.filterKeyUpSubscription?.unsubscribe();
    this.filterKeyUpSubscription = this.filterKeyUp$
      .pipe(
        tap((e) => e.event.key == "Enter" && this.initKeyUpSubscription()), // reset if enter force load already
        debounceTime(700)
      )
      .subscribe(() => { this.load().catch(this.publishError)} );
  };

  ngOnInit(): void {
    this.initKeyUpSubscription();
    this.init();
  }

  ngOnDestroy(): void {
    this.filterKeyUpSubscription?.unsubscribe();
    this.destroy();
  }

  editVolunteer = async (rec: VolunteerPointViewRecord) => {
    const volunteer = await this.volunteerService.getByIdEagerly(rec.volunteerId!);
    const modal = VolunteerEditComponent.showModal(this.modalService,volunteer);

    await firstValueFrom(modal.onHidden);
    if ( modal.content.cancelled ) {
      return;
    }
    try {
         const updatedRec = await this.volunteerPointViewService.getById(rec.id);
          this.updateRows([updatedRec]);
      } catch ( e: any ) {
        console.error(e);
        this.appState.notifyError('Failed updating handset in UI table after it was saved',this,5);
      }
  }

  showBuilding = async (rec: VolunteerPointViewRecord) => {
    super.showTab('building',rec.buildingId);
  }

  showPath = async (rec: VolunteerPointViewRecord) => {
    super.showTab('path',JSON.stringify({
      pathId: rec.pathId,
      buildingId: rec.buildingId,
      defaultPointId: rec.pointId,
    }));
  }

  onTabSelected = (bSelected: boolean) => {
    console.log("volunteer-points tab selected: " + bSelected);
    if (bSelected) {
      if (!this.bInitialized) {
        this.initialize();
      } else {
        this.load().catch(this.publishError);
      }
    }
  };

  publishError = (e:any)=>this.volunteerService.publishError(e,this,2*60);

  getName = () => "volunteer-points-table";
}
